import { render, staticRenderFns } from "./InputImage.vue?vue&type=template&id=10306f78"
import script from "./InputImage.vue?vue&type=script&lang=js"
export * from "./InputImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports